var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiBurundi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_7686)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6855 0L29.998 22.5L67.6855 45V0ZM-7.68945 0L29.998 22.5L-7.68945 45V0Z",
    fill: "#18B637"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6855 0L29.998 22.5L-7.68945 0H67.6855ZM67.6855 45L29.998 22.5L-7.68945 45H67.6855Z",
    fill: "#CF0921"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-7.68945 0H-0.666992L67.6855 40.8076V45H60.6631L-7.68945 4.19238V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9814 22.5C16.9814 25.9511 18.3524 29.2608 20.7926 31.701C23.2329 34.1413 26.5426 35.5122 29.9937 35.5122C33.4447 35.5122 36.7544 34.1413 39.1947 31.701C41.6349 29.2608 43.0059 25.9511 43.0059 22.5C43.0059 19.0501 41.6354 15.7415 39.196 13.3021C36.7565 10.8626 33.4479 9.49219 29.998 9.49219C26.5482 9.49219 23.2396 10.8626 20.8001 13.3021C18.3607 15.7415 16.9902 19.0501 16.9902 22.5H16.9814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6855 0V4.19238L-0.666992 45H-7.68945V40.8076L60.6631 0H67.6855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4316 17.5957L29.1279 17.6221L30.0068 19.0635L30.877 17.6221L32.5645 17.5869L31.7471 16.1016L32.5557 14.625L30.8682 14.5898L29.9893 13.1484L29.1191 14.5986L27.4316 14.6338L28.249 16.1104L27.4316 17.5957ZM33.1094 27.4043L34.7969 27.4307L35.6758 28.8721L36.5459 27.4307L38.2334 27.3955L37.416 25.9102L38.2246 24.4336L36.5371 24.3984L35.6582 22.957L34.7881 24.4072L33.1006 24.4424L33.918 25.9189L33.1094 27.4043ZM21.6309 27.4043L23.3184 27.4307L24.1973 28.8721L25.0762 27.4307L26.7549 27.3955L25.9375 25.9102L26.7549 24.4336L25.0674 24.3984L24.1885 22.957L23.3096 24.4072L21.6221 24.4424L22.4482 25.9189L21.6309 27.4043Z",
    fill: "#CF0921"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9885 12.8173L29.0213 14.4293L27.1446 14.4684L28.0537 16.1106L27.1446 17.7626L29.0312 17.792L30.008 19.3939L30.9753 17.7915L32.8516 17.7524L31.943 16.1014L32.8421 14.4595L30.9661 14.4204L29.9885 12.8173ZM29.9909 13.4796L30.7712 14.7592L32.2701 14.7905L31.552 16.1018L32.2782 17.4215L30.7794 17.4527L30.0065 18.7331L29.2255 17.4522L27.7196 17.4288L28.4452 16.1101L27.7196 14.7992L29.2178 14.768L29.9909 13.4796ZM35.6575 22.6259L34.6903 24.2379L32.8136 24.2769L33.7229 25.9196L32.8238 27.5712L34.7002 27.6006L35.677 29.2025L36.6443 27.6L38.5205 27.561L37.612 25.91L38.5111 24.2681L36.635 24.229L35.6575 22.6259ZM24.1885 22.6271L23.2123 24.2378L21.3336 24.277L22.2527 25.9196L21.3438 27.5712L23.2217 27.6006L24.1977 29.2013L25.1741 27.6L27.042 27.5609L26.1337 25.9104L27.0428 24.2682L25.1653 24.229L24.1885 22.6271ZM35.6598 23.2882L36.4401 24.5678L37.939 24.5991L37.2209 25.9104L37.9472 27.2301L36.4484 27.2613L35.6755 28.5417L34.8945 27.2608L33.3958 27.2374L34.1139 25.9183L33.3885 24.6078L34.8868 24.5766L35.6598 23.2882ZM24.1894 23.287L24.9704 24.5678L26.4678 24.599L25.7422 25.9099L26.4687 27.2301L24.9792 27.2613L24.1977 28.5429L23.4159 27.2608L21.9188 27.2374L22.6447 25.9183L21.9114 24.6078L23.4078 24.5766L24.1894 23.287Z",
    fill: "#18B637"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_7686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiBurundi);
export default __webpack_public_path__ + "static/media/bi Burundi.76291994e8c77299aa6866c18a9b6627.svg";
export { ForwardRef as ReactComponent };